module.exports = __webpack_public_path__ + "img/mile2m.16de04b4.jpg";